<template>
  <div
    class="flex-row-union"
    :style="{
      'flex-direction': sharedProps?.isInlineAction ? 'row-reverse': undefined,
    }"
  >
    <template
      v-for="(variant, index) in semanticButtonVariant"
      :key="variant"
    >
      <SemanticButton
        v-if="props.buttons[variant]"
        v-bind="{
          ...(sharedProps || EMPTY_OBJECT),
          ...props.buttons[variant],
        }"
        :variant="variant"
        :tooltip-position="index === (semanticButtonVariant.length - 1) ? 'left' : 'right'"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import {
  EMPTY_OBJECT,
} from '../../constants/mutables';

import {
  TSemanticButtonVariant,
  semanticButtonVariant,
} from './semantic-button.ts';
import {
  ISemanticButtonProps,
} from './semantic-button.vue';
import SemanticButton from './semantic-button.vue';

type TActualSemanticButtonProps = Omit<ISemanticButtonProps, 'variant'>;
export type TSemanticButtonGroupProps = Partial<Record<TSemanticButtonVariant, TActualSemanticButtonProps>>;
export type TSharedSemanticButtonGroupProps = Partial<Omit<TActualSemanticButtonProps, 'onClick' | 'label'>> & {
  class?: string,
};

const props = defineProps<{
  buttons: TSemanticButtonGroupProps,
  sharedProps?: TSharedSemanticButtonGroupProps,
}>();
</script>
